<template lang="pug">
  section(v-if="showSectionCategory").section-recommend#Tag
    HeadingGift.mb-sm
      h2 
        span.sub {{ giftPageBody.subTitle }}
        br 
        | {{ giftPageBody.title }}
    ItemCardList
      .item(v-for="(itemGroup, index) in itemGroups" :key="itemGroup.id")
        ItemCard(:itemGroup="itemGroup" :eventCategory="`${itemCategory.name}カテゴリ商品一覧`" :pageContents="`${itemCategory.name}タグ商品一覧`")
    .text-center(v-if="giftPageBody.itemCategoryDisplayMaxCount")
      ButtonBase(:href="`/shops/items/category/${categoryCode}/?bbLink=/gifts/${giftPageCode}/&bbLabel=${giftPageName}特集を見る&bbAction=特集ページへ遷移&bbCategory=カテゴリ商品一覧`" eventAction="商品一覧へ遷移" eventCategory="ギフトページ") もっと見る

</template>

<script>
  import HeadingGift from '../heading/HeadingGift'
  import ItemCard from '../item/ItemCardForApi'
  import ItemCardList from '../item/ItemCardList'
  import {GetItemGroupsForApi} from "../../../graphqls/ItemGroups";
  import ButtonBase from "../button/ButtonBase";

  export default {
    name: 'SectionCategoryItem',
    components: {
      ButtonBase,
      HeadingGift,
      ItemCard,
      ItemCardList
    },

    props: {
      giftPageBody: {
        type: Object,
        required: true,
        default: function () {
          return {}
        }
      },
      giftPageName: {
        type: String,
        default: ''
      },
      giftPageCode: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        itemCategory: {
          name: "",
          ogImageSet: {
            ogpImage: ''
          }
        },
        itemGroups: [],
        stockOnly: !this.$route.query?.stock || this.$route.query?.stock === 'instock',
        withinYearItem: this.$route.query.wiy === 'true',
        firstItemGroup: {ogpImageUrl: ''},
      }
    },
    computed: {
      itemCategoryId() {
        return this.giftPageBody.itemCategoryId
      },
      categoryCode() {
        return this.giftPageBody?.itemCategory?.code
      },
      stockFilter() {
        return this.giftPageBody.itemCategoryDisplayConditionStatus === 'show_category_now_on_sale_item' ? 'instock' : 'outstock'
      },
      storageFilter() {
        let orderBy = ''
        switch (this.giftPageBody.itemCategoryDisplayStorage) {
          case 'show_category_storage_all':
            orderBy = ''
            break
          case 'show_category_storage_normal':
            orderBy = 'normal'
            break
          case 'show_category_storage_cold':
            orderBy = 'cold'
            break
          case 'show_category_storage_freeze':
            orderBy = 'freeze'
            break
        }
        return orderBy
      },
      orderBy() {
        let orderBy = 'popular'
        switch (this.giftPageBody.itemCategoryDisplayOrder) {
          case 'show_category_order_popular':
            orderBy = 'popular'
            break
          case 'show_category_order_new':
            orderBy = 'new'
            break
          case 'show_category_order_low_price':
            orderBy = 'low'
            break
          case 'show_category_order_high_price':
            orderBy = 'high'
            break
        }
        return orderBy
      },
      perPage() {
        let maxCount = -1
        if (this.giftPageBody.itemCategoryDisplayMaxCount) maxCount = Number(this.giftPageBody.itemCategoryDisplayMaxCount);
        return maxCount
      },
      pageInfo() {
        return {
          currentPage: 1,
          totalCount: 0,
          perPage: this.perPage,
          orderBy: this.orderBy
        }
      },
      showSectionCategory() {
        return this.giftPageBody.itemCategory; // && this.giftPageBody.itemCategory.publishedStatus === 'published'
      },

    },
    async mounted() {
      if (this.showSectionCategory) {
        for (let i = 0; i < 8; i++) {
          this.itemGroups.push({id: i})
        }
        await this.fetchItemGroups()
      }
    },
    methods: {
      async fetchItemGroups() {
        const { data } = await this.$apollo
            .query({
              query: GetItemGroupsForApi,
              variables: {
                categoryCode: this.categoryCode,
                stockFilter: this.stockFilter,
                storageFilter: this.storageFilter,
                ...this.pageInfo

              },
              client: 'apiClient'
            })
            .catch(error => {
              this.loadingStop()
              return;
            });
        this.itemGroups = data.itemGroups.items;
        // this.pageInfo = data.itemGroups.pageInfo
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../assets/stylesheets/v1/styles";

  .section-recommend {

  }
</style>
